import { render, staticRenderFns } from "./remote-editor.vue?vue&type=template&id=b8aa2c72&scoped=true"
import script from "./remote-editor.vue?vue&type=script&lang=js"
export * from "./remote-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8aa2c72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8aa2c72')) {
      api.createRecord('b8aa2c72', component.options)
    } else {
      api.reload('b8aa2c72', component.options)
    }
    module.hot.accept("./remote-editor.vue?vue&type=template&id=b8aa2c72&scoped=true", function () {
      api.rerender('b8aa2c72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/remote-editor.vue"
export default component.exports